import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import { useState } from 'react';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { setHideUpdateAddressModule } from 'helpers/localstorage';
import { Button } from 'components/form/Button';

const UpdateAddress = props => {
  const [hideUpdateAddressBanner, setHideUpdateAddressBanner] = useState(false);

  const { cashAccount, eventHandler, history, modulePosition } = props;

  const { addressLine, city, postalCode, region } = cashAccount?.address ?? {};

  const moduleName = 'Reissue - Confirm Address';

  const onClickCloseIcon = () => {
    eventHandler(CLICK, {
      'Click Type': 'Dismiss Module',
      'Module Name': moduleName,
    });
    setHideUpdateAddressBanner(true);
    setHideUpdateAddressModule(true);
  };

  const onClickCta = () => {
    eventHandler(CLICK, {
      'Click Type': 'Update Address',
      'Module Name': moduleName,
    });
    history.push('/profile');
  };

  const seenPixel = useSeenModulePixel(
    getViewModuleTrackingAttributes({
      moduleName: moduleName,
      modulePosition: modulePosition,
    }),
  );

  if (hideUpdateAddressBanner) {
    return <></>;
  }

  return (
    <>
      {seenPixel}
      <FlexContainer className="bgBlue015 pad16 width100 margT20 margB36">
        <FlexContainer column className="format80 m-format75">
          <Label type="Subtitle-2" className="margB8">
            📍 Is your address correct?
          </Label>
          <Label type="Body-2">
            <Label inline>
              <Label inline className="toTitleCase">
                {addressLine.toLowerCase()}
              </Label>
              {', '}
              <Label inline className="toTitleCase">
                {city.toLowerCase()}
              </Label>
              {', '}
              <Label inline>{region}</Label>{' '}
              <Label inline>{postalCode.toLowerCase()} </Label>.
              <Label inline className="margL4">
                We'll send your new card here.
              </Label>
            </Label>
          </Label>
        </FlexContainer>
        <FlexContainer
          alignItemsCenter
          justifyEnd
          className="format20 m-flex-column m-format25"
        >
          <Label className="format100 m-flex-ord-2">
            <Button mrphType="primary" fullWidth onClick={onClickCta}>
              Update
            </Button>
          </Label>

          <Label
            className="format20 pointer margL24 m-flex-ord-1 m-margB20"
            onClick={onClickCloseIcon}
          >
            <Image className="notificationCloseButton" />
          </Label>
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

export default UpdateAddress;
